export default "__VITE_ASSET__CuwipYS7__"